import * as React from 'react';
import { Dispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { Action } from 'redux';

import { ToastComponent, ToastType, ToastOptions } from '@common/components';
import { CustomerViewModel } from '@models/Customer';
import { ContractViewModel, ContractDetailsViewModel } from '@models/Contract';
import { contractService } from '@services/ContractService';

// import { AppState } from '..';

import { ContractTransferComponentPage } from './_components/contract-transfer.component';
import { ContractTransferState } from './contract-transfer.reducer';

// We can use enums instead of type constants like in the example. This is a newer TS feature
export enum ContractTransferActionType {
  Close = 'Close',
  GetContractFailure = 'GetContractFailure',
  GetContractStart = 'GetContractStart',
  GetContractSuccess = 'GetContractSuccess',
  GotoPage = 'GotoPage',
  Reset = 'Reset',
  SetCustomer = 'SetCustomer',
  TransferContractFailure = 'TransferContractFailure',
  TransferContractStart = 'TransferContractStart',
  TransferContractSuccess = 'TransferContractSuccess'
}

// This is defining the action definition for certain actions on the page.
// There may be multiple types of these on a given page.
// All properties should be readonly.
interface ContractTransferAction extends Action {
  readonly type: ContractTransferActionType;
}

export interface CloseAction extends ContractTransferAction {}

export interface GetContractFailureAction extends ContractTransferAction {}
export interface GetContractStartAction extends ContractTransferAction {}
export interface GetContractSuccessAction extends ContractTransferAction {
  readonly contract: ContractDetailsViewModel;
}

export interface GotoPageAction extends ContractTransferAction {
  readonly page: ContractTransferComponentPage;
}

export interface ResetAction extends ContractTransferAction {}

export interface SetCustomerAction extends ContractTransferAction {
  readonly customer?: CustomerViewModel;
}

export interface TransferContractFailureAction extends ContractTransferAction {}
export interface TransferContractStartAction extends ContractTransferAction {}
export interface TransferContractSuccessAction extends ContractTransferAction {}

// Actions for each action type declared here.
// They should all return an action object.
export function close(): CloseAction {
  return {
    type: ContractTransferActionType.Close
  };
}

export function getContract(id: number) {
  return async (dispatch: Dispatch<ContractTransferState>) => {
    dispatch(getContractStart());
    try {
      const contract: ContractDetailsViewModel = await contractService.getContractDetails(id);
      dispatch(getContractSuccess(contract));
    } catch (e) {
      dispatch(getContractFailure());
    }
  };
}

export function getContractFailure(): GetContractFailureAction {
  toast.error(
    <ToastComponent type={ToastType.Error} message={'Error fetching data from network.'} />,
    ToastOptions.Error
  );
  return {
    type: ContractTransferActionType.GetContractFailure
  };
}

export function getContractStart(): GetContractStartAction {
  return {
    type: ContractTransferActionType.GetContractStart
  };
}

export function getContractSuccess(contract: ContractDetailsViewModel): GetContractSuccessAction {
  return {
    type: ContractTransferActionType.GetContractSuccess,
    contract: contract
  };
}

export function gotoPage(page: ContractTransferComponentPage): GotoPageAction {
  return {
    type: ContractTransferActionType.GotoPage,
    page: page
  };
}

export function reset(): ResetAction {
  return {
    type: ContractTransferActionType.Reset
  };
}

export function setCustomer(customer?: CustomerViewModel): SetCustomerAction {
  return {
    type: ContractTransferActionType.SetCustomer,
    customer: customer
  };
}

export function transferContract(id: number, customerId: number) {
  return async (dispatch: Dispatch<ContractTransferState>) => {
    dispatch(transferContractStart());
    try {
      const contract: ContractViewModel = await contractService.getContract(id);
      contract.buyerId = customerId;
      await contractService.updateContract(id, contract);
      dispatch(transferContractSuccess());
    } catch (e) {
      dispatch(transferContractFailure());
    }
  };
}

export function transferContractFailure(): TransferContractFailureAction {
  toast.error(
    <ToastComponent type={ToastType.Error} message={'Error fetching data from network.'} />,
    ToastOptions.Error
  );
  return {
    type: ContractTransferActionType.TransferContractFailure
  };
}

export function transferContractStart(): TransferContractStartAction {
  return {
    type: ContractTransferActionType.TransferContractStart
  };
}

export function transferContractSuccess(): TransferContractSuccessAction {
  return {
    type: ContractTransferActionType.TransferContractSuccess
  };
}



// WEBPACK FOOTER //
// ./src/contract/_components/contract-transfer/contract-transfer.actions.tsx